import { Injectable } from '@angular/core';
import { DatabaseProvider } from '../database/database';

@Injectable()
export class ConfigDataProvider {

	private userData: any = {};
	private mobileKey: string = "";
	private customerCode: string = "";
	private deviceUUID: string = "";
	private userProfilePicture: string = "";
	private customerName: any;
	private permissionsArray = [];

	private db = new DatabaseProvider();

	constructor(
	) {
	}

	public setUserData(user) {
		this.userData = user;
		localStorage.setItem('user', JSON.stringify(user));
	}

	public getUserData() {
		this.userData = JSON.parse(localStorage.getItem('user'));
		return this.userData;
	}

	public setUserProfilePicture(userPicture) {
		this.userProfilePicture = userPicture;
		localStorage.setItem('userProfilePicture', userPicture);
	}

	public getUserProfilePicture() {
		this.userProfilePicture = localStorage.getItem('userProfilePicture');
		return this.userProfilePicture;
	}

	public setMobileKey(mobileKey) {
		this.mobileKey = mobileKey;
		localStorage.setItem('mobile_key', mobileKey);
	}

	public getMobileKey() {
		this.mobileKey = localStorage.getItem('mobile_key');
		return this.mobileKey;
	}

	public setLanguageType(language) {
		localStorage.setItem("opyxLang", language);
	}

	public getLanguageType() {
		return localStorage.getItem("opyxLang") ? localStorage.getItem("opyxLang") : "en";
	}

	public clearLocalStorage() {
		localStorage.clear();
		localStorage.setItem('caredocurl', "https://login.opyx.net");
	}

	public setCustomerCode(customercode) {
		this.customerCode = customercode;
		localStorage.setItem('customercode', customercode);
	}

	public getCustomerCode() {
		this.customerCode = localStorage.getItem('customercode');
		return this.customerCode;
	}

	public setCustomerName(customername) {
		this.customerName = customername;
		localStorage.setItem('customername', customername);
	}

	public getCustomerName() {
		this.customerName = localStorage.getItem('customername');
		return this.customerName;
	}	

	public getcaredocurl() {
		return localStorage.getItem('caredocurl');

	}

	public setDeviceUUID(deviceUUID) {
		this.deviceUUID = deviceUUID;
		localStorage.setItem('deviceUUID', deviceUUID);
	}

	public getDeviceUUID() {
		this.deviceUUID = localStorage.getItem("deviceUUID");
		return this.deviceUUID;
	}

	public logout() {
		return new Promise((resolve, reject) => {

			let promiseArray = [
				this.db.advalvas.clear(),
				this.db.messages.clear(),
				this.db.attachments.clear(),
				this.db.tasks.clear(),
				this.db.users.clear(),
				this.db.werkbonType.clear(),
				this.db.afdelingen.clear(),
				this.db.categories.clear(),
				this.db.rooms.clear(),
				this.db.messageTemplates.clear(),
				this.db.myUsers.clear(),
				this.db.calendars.clear(),
				this.db.calendarItems.clear()
			];

			localStorage.clear();
			localStorage.setItem('caredocurl', "https://login.opyx.net")

			Promise.all(promiseArray).then((data) => {
				resolve(true)
			}).catch((e) => reject(e));
		})
	}

	public storePermissions(permissions) {
		this.permissionsArray = permissions;
		localStorage.setItem('permissions', JSON.stringify(this.permissionsArray));
	}

	public getPermissions() {
		let permissions: any = localStorage.getItem('permissions');
		permissions = !permissions && permissions != null && permissions != undefined ? [] : JSON.parse(permissions);
		this.permissionsArray = permissions;
		return this.permissionsArray;
	}
}



// WEBPACK FOOTER //
// ./src/providers/config-data/config-data.ts